import React from "react";
import {
    Bar,
    BarChart,
    CartesianGrid,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "../misc/Card";
import { formatShortDate } from "./labels";

interface PostsPerDayChartProps {
    perDay: { date: string; count: number }[];
}

const NAVY = "#193456";
const GRID = "#D5DBE1";
const AXIS = "#6b7280";

const PostsPerDayChart: React.FC<PostsPerDayChartProps> = ({ perDay }) => {
    const data = perDay.map((d) => ({ ...d, label: formatShortDate(d.date) }));
    const tickEvery = Math.max(1, Math.ceil(data.length / 10));
    return (
        <Card className="mt-0">
            <CardHeader className="pb-2">
                <CardTitle className="text-left text-base">Posts per day</CardTitle>
            </CardHeader>
            <CardContent>
                <ResponsiveContainer width="100%" height={240}>
                    <BarChart data={data} margin={{ top: 8, right: 8, left: -16, bottom: 0 }}>
                        <CartesianGrid stroke={GRID} strokeDasharray="3 3" vertical={false} />
                        <XAxis
                            dataKey="label"
                            interval={tickEvery - 1}
                            tick={{ fill: AXIS, fontSize: 12 }}
                            axisLine={{ stroke: GRID }}
                            tickLine={false}
                        />
                        <YAxis
                            allowDecimals={false}
                            tick={{ fill: AXIS, fontSize: 12 }}
                            axisLine={false}
                            tickLine={false}
                        />
                        <Tooltip
                            cursor={{ fill: "#F0DFAF", opacity: 0.4 }}
                            formatter={(value: number) => [value, "Posts"]}
                        />
                        <Bar dataKey="count" fill={NAVY} radius={[4, 4, 0, 0]} />
                    </BarChart>
                </ResponsiveContainer>
            </CardContent>
        </Card>
    );
};

export default PostsPerDayChart;
